import { render } from "./productConfigurationFlexLicense.vue?vue&type=template&id=a48b558e&scoped=true&ts=true"
import script from "./productConfigurationFlexLicense.vue?vue&type=script&lang=ts"
export * from "./productConfigurationFlexLicense.vue?vue&type=script&lang=ts"

import "./productConfigurationFlexLicense.vue?vue&type=style&index=0&id=a48b558e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a48b558e"]])

export default __exports__